import {Component, OnInit} from '@angular/core';
import {MatDialog} from "@angular/material";

@Component({
    selector: 'app-error-dialog',
    templateUrl: './error-dialog.component.html',
    styleUrls: ['./error-dialog.component.css']
})
export class ErrorDialogComponent implements OnInit {

    constructor(public dialog: MatDialog) {

    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/dialogs/error-dialog/error-dialog.component.ts